import { withInstall, withNoopInstall } from '@bigin/utils'

import Container from './src/container.vue'
import Aside from './src/aside.vue'
import Footer from './src/footer.vue'
import Header from './src/header.vue'
import Main from './src/main.vue'
import Spacer from './src/spacer.vue'

export const BContainer = withInstall(Container, {
  Aside,
  Footer,
  Header,
  Main,
  Spacer,
})

export default BContainer
export const BAside = withNoopInstall(Aside)
export const BFooter = withNoopInstall(Footer)
export const BHeader = withNoopInstall(Header)
export const BMain = withNoopInstall(Main)
export const BSpacer = withNoopInstall(Spacer)

export type BContainerInstance = InstanceType<typeof Container>
export type BAsideInstance = InstanceType<typeof Aside>
export type BFooterInstance = InstanceType<typeof Footer>
export type BHeaderInstance = InstanceType<typeof Header>
export type BMainInstance = InstanceType<typeof Main>
export type BSpacerInstance = InstanceType<typeof Spacer>
